import { render } from "./NotFound.vue?vue&type=template&id=381c4f0b&scoped=true"
const script = {}

import "./NotFound.vue?vue&type=style&index=0&id=381c4f0b&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-381c4f0b"]])

export default __exports__